import ItemAttachmentPreview from './ItemAttachmentPreview';
import { observer } from 'mobx-react-lite';
import { AttachmentPreviewMethod } from 'owa-attachment-data';
import { IcsPreview, IcsPreviewState } from 'owa-preview-ics';
import { SxSExtendedViewState } from 'owa-sxs-store';
import * as React from 'react';

export interface SxSCustomViewProps {
    onError: (errorMessage: string, error?: Error) => void;
    onLoad: () => void;
    viewState: SxSExtendedViewState;
    customPreviewState: any;
}

const SxSCustomView = observer(function SxSCustomView(props: SxSCustomViewProps) {
    if (props.viewState.previewMode === AttachmentPreviewMethod.ItemAttachment) {
        return (
            <ItemAttachmentPreview
                attachmentId={props.viewState.attachmentId}
                onError={props.onError}
                onLoad={props.onLoad}
            />
        );
    } else if (props.viewState.previewMode === AttachmentPreviewMethod.CalendarEvent) {
        return <IcsPreview viewState={props.customPreviewState as IcsPreviewState} />;
    }

    return null;
});
export default SxSCustomView;
